import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/employees'
const API_URL_EMPLOYEE = process.env.VUE_APP_BASE_API_URL + '/api/v1/employee'

class EmployeeApi {
  getList(page, size) {
    return axios.get(API_URL + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  createEmployee(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  editEmployee(uuid, data) {
    return axios.put(API_URL + '/' + uuid, data, { headers: authHeader() })
  }

  getPlanForCalendar(uuid, start, end) {
    return axios.get(
      API_URL +
        '/' +
        uuid +
        '/plan?startDate=' +
        start +
        '&endDate=' +
        end +
        '&perPage=1000',
      { headers: authHeader() }
    )
  }

  getCsvExport(uuid, start, end) {
    return axios.get(
      API_URL +
        '/' +
        uuid +
        '/plan/_export/csv?startDate=' +
        start +
        '&endDate=' +
        end +
        '&perPage=1000',
      { headers: authHeader(), responseType: 'blob' }
    )
  }

  createPlan(uuid, data) {
    return axios.post(API_URL + '/' + uuid + '/plan', data, {
      headers: authHeader()
    })
  }

  getPlan(employeeUUID, uuid) {
    return axios.get(API_URL + '/' + employeeUUID + '/plan/' + uuid, {
      headers: authHeader()
    })
  }

  deletePlan(employeeUUID, uuid) {
    return axios.delete(API_URL + '/' + employeeUUID + '/plan/' + uuid, {
      headers: authHeader()
    })
  }

  deletePlanRange(employeeUUID, data) {
    return axios.post(
      API_URL + '/' + employeeUUID + '/plan-range-delete',
      data,
      {
        headers: authHeader()
      }
    )
  }

  employeeGetPlanForCalendar(start, end) {
    return axios.get(
      API_URL_EMPLOYEE +
        '/plan?startDate=' +
        start +
        '&endDate=' +
        end +
        '&perPage=1000',
      { headers: authHeader() }
    )
  }

  employeeGetPlanForCsvExport(start, end) {
    return axios.get(
      API_URL_EMPLOYEE +
        '/plan/_export/csv?startDate=' +
        start +
        '&endDate=' +
        end +
        '&perPage=1000',
      { headers: authHeader(), responseType: 'blob' }
    )
  }

  employeeCreatePlan(data) {
    return axios.post(API_URL_EMPLOYEE + '/plan', data, {
      headers: authHeader()
    })
  }

  employeeGetPlan(uuid) {
    return axios.get(API_URL_EMPLOYEE + '/plan/' + uuid, {
      headers: authHeader()
    })
  }

  employeeDeletePlan(uuid) {
    return axios.delete(API_URL_EMPLOYEE + '/plan/' + uuid, {
      headers: authHeader()
    })
  }

  employeeDeletePlanRange(data) {
    return axios.post(API_URL_EMPLOYEE + '/plan-range-delete', data, {
      headers: authHeader()
    })
  }
}

export default new EmployeeApi()
